/* eslint-disable @typescript-eslint/no-magic-numbers */
import { IsOptional, MaxLength } from "class-validator";

import "reflect-metadata";

export class CompanyDto {
  id: number;

  @MaxLength(255)
  name: string;

  @IsOptional()
  @MaxLength(32)
  code?: string;

  @IsOptional()
  @MaxLength(255)
  dbName?: string;

  @IsOptional()
  @MaxLength(10)
  dbStructure?: string;
}
